import {
    REQUEST_PURCHASE_TEMPLATES,
    FETCH_PURCHASE_TEMPLATES_SUCCESS,
    FETCH_PURCHASE_TEMPLATES_FAILURE,
    SELECT_PURCHASE_TEMPLATE,
    RESET_CURRENT_PURCHASE_TEMPLATE,
    REQUEST_PURCHASE_TEMPLATE_DETAIL,
    FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS,
    FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE,
    REQUEST_CREATING_PURCHASE_TEMPLATE,
    CREATE_PURCHASE_TEMPLATE_SUCCESS,
    CREATE_PURCHASE_TEMPLATE_FAILURE,
    REQUEST_EDITING_PURCHASE_TEMPLATE,
    EDIT_PURCHASE_TEMPLATE_SUCCESS,
    EDIT_PURCHASE_TEMPLATE_FAILURE,
    DELETE_PURCHASE_TEMPLATE,
    DELETE_PURCHASE_TEMPLATE_SUCCESS,
    DELETE_PURCHASE_TEMPLATE_FAILURE,
    REQUEST_PURCHASE_TEMPLATE_LIST,
    FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS,
    FETCH_PURCHASE_TEMPLATE_LIST_FAILURE,



} from '../actions/type';

const INITIAL_STATE = {
    all: [],
    currentPurchaseTemplate: null,
    currentPurchaseTemplateDetail: null,
    isLoading: true,
    error: null,
    detailIsLoading: false,
    detailError: null,
    purchaseTemplateIsCreating: false,
    purchaseTemplateCreateError: null,
    purchaseTemplateCreated: null,
    purchaseTemplateIsEditing: false,
    purchaseTemplateEditError: null,
    purchaseTemplateEdited: false,
    currentPurchaseProduct: null,
    purchaseTemplateIsDeleting: true,
    purchaseTemplateDeleteError: null,
    purchaseTemplateDeleted: false,
    purchaseTemplateList:[],
    purchaseTemplateListIsLoading: false,
    purchaseTemplateListError: null,

};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        // Product action handlers
        case REQUEST_PURCHASE_TEMPLATES:
            return { ...state, error: null, isLoading: true };
        case FETCH_PURCHASE_TEMPLATES_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_PURCHASE_TEMPLATES_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_PURCHASE_TEMPLATE:
            return {...state, currentPurchaseTemplate: action.payload };
        case RESET_CURRENT_PURCHASE_TEMPLATE:
            return { ...state, currentPurchaseTemplate: null, currentPurchaseTemplateDetail: null, purchaseTemplateEditError: null, purchaseTemplateCreateError: null, purchaseTemplateCreated: null };
        case REQUEST_PURCHASE_TEMPLATE_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentPurchaseTemplateDetail: action.payload, detailError: null, detailIsLoading: false };
        case FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_CREATING_PURCHASE_TEMPLATE:
            return { ...state, purchaseTemplateIsCreating: true, purchaseTemplateCreateError: null, purchaseTemplateCreated: null };
        case CREATE_PURCHASE_TEMPLATE_SUCCESS:
            return { ...state, purchaseTemplateIsCreating: false, purchaseTemplateCreateError: null, purchaseTemplateCreated: action.payload.data };
        case CREATE_PURCHASE_TEMPLATE_FAILURE:
            const purchaseTemplateCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseTemplateIsCreating: false, purchaseTemplateCreateError: purchaseTemplateCreateError, purchaseTemplateCreated: null };
        case REQUEST_EDITING_PURCHASE_TEMPLATE:
            return { ...state, purchaseTemplateIsEditing: true, purchaseTemplateEditError: null, purchaseTemplateEdited: false, purchaseTemplateCreated: null };
        case EDIT_PURCHASE_TEMPLATE_SUCCESS:
            return { ...state, purchaseTemplateIsEditing: false, purchaseTemplateEditError: null, purchaseTemplateEdited: true };
        case EDIT_PURCHASE_TEMPLATE_FAILURE:
            const purchaseTemplateEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseTemplateIsEditing: false, purchaseTemplateEditError: purchaseTemplateEditError, purchaseTemplateEdited: false };
        case DELETE_PURCHASE_TEMPLATE:
            return { ...state, purchaseTemplateIsDeleting: true, purchaseTemplateDeleteError: null, purchaseTemplateDeleted: false };
        case DELETE_PURCHASE_TEMPLATE_SUCCESS:
            return { ...state, purchaseTemplateIsDeleting: false, purchaseTemplateDeleteError: null, purchaseTemplateDeleted: true };
        case DELETE_PURCHASE_TEMPLATE_FAILURE:
            const purchaseTemplateDeleteError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseTemplateIsDeleting: false, purchaseTemplateDeleteError: purchaseTemplateDeleteError, purchaseTemplateDeleted: false };
        case REQUEST_PURCHASE_TEMPLATE_LIST:
            return { ...state, purchaseTemplateListIsLoading: true, purchaseTemplateList: [], purchaseTemplateListError: null };
        case FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS:
            return { ...state, purchaseTemplateListIsLoading: false, purchaseTemplateList: action.payload.data };
        case FETCH_PURCHASE_TEMPLATE_LIST_FAILURE:
            const purchaseTemplateListError = action.payload.data || { message: action.payload.message };
            return { ...state, purchaseTemplateListIsLoading: false, purchaseTemplateListError: purchaseTemplateListError };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/purchaseTemplates_reducer.js